import React from 'react';
import { DeckGLLayer } from '@leverege/ui-google-maps-elements';
import { HeatmapLayer } from '@deck.gl/aggregation-layers';
import { Attributes } from '@leverege/ui-attributes';
import { ValuesCache } from '@leverege/value-cache';
import Model from "./HeatmapModel.js";
import Util from "./Util.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default class HeatmapRenderer extends React.Component {
  constructor(options) {
    super(options);
    const {
      relationship,
      attributeName
    } = options;
    const {
      path
    } = relationship;
    const groupId = options?.items?.id || '';
    this.id = `${path}:${attributeName}:${groupId}`;
    this.attributeName = attributeName;
    this.cache = new ValuesCache();
  }
  getLayerOptions(items, ...rest) {
    return this.cache.calc('layerOptions', layerOptions, items, ...rest);
  }
  render() {
    const {
      items,
      zoom,
      model
    } = this.props;
    const data = items?.[0]?.items;
    return /*#__PURE__*/_jsx(DeckGLLayer, {
      layer: new HeatmapLayer({
        ...this.getLayerOptions(items, zoom, model),
        id: this.id,
        pickable: false,
        data,
        getPosition: d => {
          const pos = Attributes.get(this.attributeName, d.type, d.data);
          if (pos) {
            return [pos.lon, pos.lat];
          }
          return null;
        }
      })
    });
  }
}
function layerOptions(items, zoom, model) {
  const colorRange = Model.getColorRanges(model);
  const show = Model.getShowAtZoom(model);
  const hide = Model.getHideAtZoom(model);
  const visible = Util.getVisible(show, hide, zoom);
  return {
    visible,
    radiusPixels: Model.getBlobRadius(model),
    colorRange: colorRange && colorRange.length > 0 ? colorRange.map(Util.colorStringToArray) : Model.DEFAULT_COLOR_RANGE.map(Util.colorStringToArray),
    intensity: Model.getIntensity(model),
    aggregation: Model.getAggregation(model),
    weightsTextureSize: Model.getWeightsTextureSize(model)
  };
}